/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type OverviewInstagram_tradeFirm = {
    readonly serviceId: string | null;
    readonly instagram: {
        readonly username?: string | null;
        readonly feed: ReadonlyArray<{
            readonly imageUrl: string | null;
            readonly link: string | null;
        } | null> | null;
    } | null;
    readonly " $refType": "OverviewInstagram_tradeFirm";
};
export type OverviewInstagram_tradeFirm$data = OverviewInstagram_tradeFirm;
export type OverviewInstagram_tradeFirm$key = {
    readonly " $data"?: OverviewInstagram_tradeFirm$data;
    readonly " $fragmentRefs": FragmentRefs<"OverviewInstagram_tradeFirm">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "OverviewInstagram_tradeFirm",
  "type": "TradeFirmType",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isEditMode",
      "type": "Boolean"
    }
  ],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "serviceId",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "instagram",
      "storageKey": null,
      "args": null,
      "concreteType": "InstagramFeedType",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "feed",
          "storageKey": null,
          "args": null,
          "concreteType": "InstagramFeedItemType",
          "plural": true,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "imageUrl",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "link",
              "args": null,
              "storageKey": null
            }
          ]
        },
        {
          "kind": "Condition",
          "passingValue": true,
          "condition": "isEditMode",
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "username",
              "args": null,
              "storageKey": null
            }
          ]
        }
      ]
    }
  ]
};
(node as any).hash = '89d3ef04b6cacadaef9193b65a1a2cfd';
export default node;
